// extracted by mini-css-extract-plugin
export var container = "_dm-1";
export var cornerButtonContainer = "_dm-6";
export var disabled = "_dm-2";
export var dragActive = "_dm-3";
export var fileContainer = "_dm-5";
export var hiddenInput = "_dm-4";
export var widthContainer = "_dm-0";